module.exports = __webpack_public_path__ + "static/media/video1_cut.46b2c4af.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/video1_cut.mp4
// module id = 804
// module chunks = 0